import namespaces from './ns';
import { DEFAULT_LANG, asLang, getActiveLang } from './lang';
import { interpolate } from './interpolate';

function lookup(lang, key) {
  const [ns, ...path] = key.split('.');
  return path.reduce((node, part) => (node == null ? undefined : node[part]), namespaces[ns]?.[lang]);
}

/**
 * Translate a key from code that cannot use the useI18n() hook (the API client,
 * the auth context, utils/). Components keep using useI18n().t.
 *
 * Only the per-namespace modules in ns/ are searched, in the language the user picked
 * (Uzbek until they switch: the language is read from localStorage 'crm-lang'). A missing
 * translation falls back to Uzbek, then English, then `fallback`, then the key.
 *
 * @param {string} key - e.g. 'shell.errors.forbidden'
 * @param {string} [fallback] - text to use when the key is missing everywhere
 * @param {object} [vars] - values for {name} placeholders
 * @param {string} [lang] - answer in this language instead of the user's
 * @returns {string}
 */
export function translate(key, fallback, vars, lang) {
  let text = lookup(asLang(lang) || getActiveLang(), key);
  if (typeof text !== 'string') text = lookup(DEFAULT_LANG, key);
  if (typeof text !== 'string') text = lookup('en', key);
  if (typeof text !== 'string') text = fallback ?? key;
  return interpolate(text, vars);
}
